import React from "react"
import { Link } from "react-router-dom"
import { Header, Image, Card } from "semantic-ui-react"


const ImageCard = ( { image } ) => <Card as={Link} to={`/bildwelt/${image.category}/${image.slug}`}>
  <Image src={image.img}/>
  <Card.Content>
    <div>
      <div className="f6  ttu black-60">Bildwelt</div>
      <div className="f5"> {image.title}</div>
    </div>
    {/*<pre>{JSON.stringify(image, null, 2)}</pre>*/}
  </Card.Content>
</Card>

export default ImageCard


// WEBPACK FOOTER //
// ./src/components/ShoppableImage/ImageCard.js